define('OutSystems/ReactWidgets/Container',["require", "exports", "tslib", "OutSystems/ReactView/AnimatedGroup", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/ScrollExtensions", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, AnimatedGroup_1, HtmlTags_1, ScrollExtensions, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Container = void 0;
    var Container = (function (_super) {
        tslib_1.__extends(Container, _super);
        function Container() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Container_1 = Container;
        Container.toHtmlAlign = function (align) {
            switch (align) {
                case 2:
                    return "center";
                case 1:
                    return "left";
                case 3:
                    return "right";
                case 0:
                    return undefined;
                default:
                    return undefined;
            }
        };
        Container.prototype.serializeCustomStateProperties = function () {
            return ScrollExtensions.serializeScrollProperties(this.getHTMLNode());
        };
        Container.prototype.loadCustomStateProperties = function (customProperties) {
            ScrollExtensions.loadScrollProperties(this.getHTMLNode(), customProperties);
        };
        Object.defineProperty(Container.prototype, "skipRenderWhenHidden", {
            get: function () {
                return false;
            },
            enumerable: false,
            configurable: true
        });
        Container.prototype.render = function () {
            var container = null;
            if (this.props.visible) {
                var style = {
                    textAlign: Container_1.toHtmlAlign(this.props.align),
                    cursor: this.props.extendedEvents && this.props.extendedEvents.onClick ? "pointer" : undefined,
                };
                var containerAttributes = {
                    "data-container": "",
                    className: this.props.style,
                    style: style,
                };
                this.fillWithBuiltinProperties(containerAttributes);
                container = React.createElement(HtmlTags_1.HtmlTags.div, containerAttributes, this.props.children);
            }
            var disabledAnimation = true;
            return !disabledAnimation && this.props.animate
                ? React.createElement(AnimatedGroup_1.AnimatedGroup, {}, container)
                : container;
        };
        var Container_1;
        Container = Container_1 = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Container);
        return Container;
    }(Widget_1.Widget));
    exports.Container = Container;
});
//# sourceMappingURL=Container.js.map;
